import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TheFooterContact = _resolveComponent("TheFooterContact")!
  const _component_TheFooterBar = _resolveComponent("TheFooterBar")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({ isLoggedIn: _ctx.isLoggedIn, isScrollBlocked: _ctx.blockScroll })
  }, [
    _createVNode(_component_TheHeader),
    _createVNode(_component_router_view),
    _withDirectives(_createVNode(_component_TheFooterContact, null, null, 512), [
      [_vShow, !(_ctx.isIkeaClient && _ctx.$route.name == 'order')]
    ]),
    _createVNode(_component_TheFooterBar)
  ], 2))
}